import { Output, Directive, NgModule, EventEmitter, HostListener, ElementRef, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Directive({
    selector: '[w-click-outside]',
    standalone: false
})
/*
@id w-click-outside
@name w-click-outside
@status release
@description directive to emit an event on mouse click outside of the element
*/
export class WClickOutsideDirective {

  @Input() clickInsiders: HTMLElement[] = []; // other DOM elements that does not trigger clickOutside event
  @Output() clickOutside = new EventEmitter<void>(); // emits event if clicked outside
  
  constructor(private _elementRef: ElementRef) {  }

  @HostListener('document:click', ['$event'])
  onClick(event: MouseEvent) {
    const insiders = [this._elementRef.nativeElement, ...this.clickInsiders];
    const path = event?.composedPath() as HTMLElement[];
    const clickedInside = insiders.some((i: HTMLElement) => path.includes(i));
    
    if (!clickedInside) {
      this.clickOutside.emit();
    }
  }
  parents(element: HTMLElement): string {
    const x = this._elementRef.nativeElement === element;
    if (element.parentElement) {
      return this.parents(element.parentElement) +  '>' + (x ? '*' : '') + element.tagName;
    } else {
      return '!' + (x ? '*' : '') + element.tagName;
    }
  }
}
@NgModule({
  imports: [CommonModule],
  exports: [WClickOutsideDirective],
  declarations: [WClickOutsideDirective]
})
export class WClickOutsideModule { }